import React, {Component} from 'react'
import { connect } from 'react-redux'

// import styles
import './booking.scss'

// Actions
import { getBookingInformation, saveBookingInformation } from '../../../actions/settings'

// Elements
import Row from '../../../shared/elements/row'
import Panel from '../../../shared/elements/panel'
import Col from '../../../shared/elements/col'
import Grid from '../../../shared/elements/grid'
import Inline from '../../../shared/elements/inline'
import Label from '../../../shared/elements/label'
import Check from '../../../shared/elements/check'
import DropDown from '../../../shared/elements/dropDown'

// Utils
import { translation } from '../../../utils/helpers'

class Booking extends Component {

  constructor (props) {
    super(props)
    this.state = {
      Booking: {
        ShopId: 0,
        OpeningHours: [],
        BookingStart: [],
        BookingEnd: [],
        DefaultHours: 0,
        DeliveryPlusDriving: false,
        DeliveryHourPrices: []
      }
    }
    this.onChange = this.onChange.bind(this)
    this.onBlur = this.onBlur.bind(this)
  }

  componentDidMount () {
    this.getBookingInformation()
  }

  getBookingInformation () {
    this.props.getBookingInformation(this.props.auth.user.ShopId).then((res) => {
      this.setState({
        Booking: {
          ShopId: res.data.ShopId,
          OpeningHours: res.data.OpeningHours,
          BookingStart: res.data.BookingStart,
          BookingEnd: res.data.BookingEnd,
          DefaultHours: res.data.DefaultHours,
          DeliveryPlusDriving: res.data.DeliveryPlusDriving,
          DeliveryHourPrices: res.data.DeliveryHourPrices

        }})
    }, (err) => {
      console.log(err)
    })
  }

  onChange (e) {
    e.persist()
    this.setState({
      Booking: {
        ...this.state.Booking,
        [e.target.name]: e.target.value
      }
    }, () => {})
  }

  onBlur (e) {
    this.props.saveBookingInformation(this.state.Booking).then(() => {
      // Toastr (replace dict. key)
      // window.toastr.success(translation('1823'), translation('13424'))
    }, () => {
      // Toastr (replace dict. key)
      window.toastr.error(translation('1824'), translation('216'))
    })
  }

  render () {
    let booking = this.state.Booking

    const renderDays = (days, array) => {
      const renderDay = (daySetting, key) => {
        let dayString = ''
        switch (daySetting.Day) {
          case 0:
            dayString = translation('175')
            break
          case 1:
            dayString = translation('169')
            break
          case 2:
            dayString = translation('170')
            break
          case 3:
            dayString = translation('171')
            break
          case 4:
            dayString = translation('172')
            break
          case 5:
            dayString = translation('173')
            break
          case 6:
            dayString = translation('174')
            break
        }

        const onChange = (e) => {
          e.persist()
          let value = e.target.value
          if (e.target.type === 'checkbox') {
            value = e.target.checked
          }
          let newDays = [...this.state.Booking[array]]
          newDays[key][e.target.name] = value
          this.setState({
            Booking: {
              ...this.state.Booking,
              [array]: newDays
            }
          }, () => {
            if (e.target.type === 'checkbox' || e.target.type === 'radio') {
              this.onBlur(e)
            }
          })
        }

        const renderFromToTime = (array, key) => {
          const onChange = (e) => {
            let field = e.target.name
            let value = e.target.value
            let newDays = [...this.state.Booking[array]]
            newDays[key][field] = value
            this.setState({
              Booking: {
                ...this.state.Booking,
                [array]: newDays
              }
            }, () => {
              this.onBlur(e)
            })
          }

          let displayFrom = daySetting.From
          let displayTo = daySetting.To

          let timeOptions = []
          for (let h = 0; h < 24; h++) {
            let hour = h < 10 ? '0' + h : h.toString()
            timeOptions.push(hour + ':00')
            timeOptions.push(hour + ':30')
          }

          return (
            <span className='fromtotimepicker'>
              <Inline>
                <DropDown value={displayFrom} onChange={onChange} name='From' ref={displayFrom} size='m'>
                  {timeOptions.map((val, index) => {
                    return <option value={val} key={'From_' + index}>{val}</option>
                  })}
                </DropDown>
                <DropDown value={displayTo} onChange={onChange} name='To' ref={displayTo} size='m'>
                  {timeOptions.map((val, index) => {
                    return <option value={val} key={'To_' + index}>{val}</option>
                  })}
                </DropDown>
              </Inline>
            </span>
          )
        }

        return (
          <Grid cols={[ 2, 1, 3 ]} align='center' key={key}>
            <Label>{dayString}</Label>
            <Check name='Available' value='1' checked={daySetting.Available} onChange={onChange} simple />
            {renderFromToTime(array, key)}
          </Grid>
        )
      }

      return (
        <div>
          <Grid cols={[ 2, 1, 3 ]} align='center'>
            <span>{translation('483')}</span>
            <span>{translation('1780')}</span>
            <span>{translation('1781')}</span>
          </Grid>

          {days.map(renderDay)}
        </div>
      )
    }

    return (
      <Row>
        <Col span='2'>
          <Panel title={translation('195')} helpText={translation('1982')}>
            {renderDays(booking.BookingStart, 'BookingStart')}
          </Panel>
        </Col>

        <Col span='2'>
          <Panel title={translation('196')} helpText={translation('1983')}>
            {renderDays(booking.BookingEnd, 'BookingEnd')}
          </Panel>
        </Col>

        <Col span='2'>
          <Panel title={translation('186')} helpText={translation('1984')}>
            {renderDays(booking.OpeningHours, 'OpeningHours')}
          </Panel>
        </Col>

      </Row>
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  getBookingInformation,
  saveBookingInformation
})(Booking)




// WEBPACK FOOTER //
// ./src/app/pages/Settings/Booking/index.js